(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["charlox-buy-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('charlox-buy-controls')) {
  customElements.define('charlox-buy-controls', class extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.label) return;
      this.updateLabel = () => {
        const button = this.querySelector('button[name="add"]');
        const label = button?.querySelector('span');
        if (button && !button.disabled && label?.textContent.trim() === this.dataset.defaultLabel) label.textContent = this.dataset.label;
      };
      this.observer = new MutationObserver(this.updateLabel);
      this.observer.observe(this, { childList:true, subtree:true, attributes:true, attributeFilter:['disabled'] });
      this.updateLabel();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["charlox-gift-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    function updateGiftCards() {
      document.querySelectorAll('[data-charlox-gift-end]:not([data-preview-only])').forEach(card => {
        const end = Date.parse(card.dataset.charloxGiftEnd);
        if (Number.isFinite(end) && Date.now() > end) card.hidden = true;
      });
    }
    updateGiftCards();
    document.addEventListener('shopify:section:load', updateGiftCards);
    setInterval(updateGiftCards, 30000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["charlox-product-video"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('charlox-demo')) {
  customElements.define('charlox-demo',class extends HTMLElement {
    connectedCallback() {
      if(this.initialized)return;
      this.initialized=true;
      this.querySelector('.charlox-demo__trigger')?.addEventListener('click',()=>{
        const content=this.querySelector('template')?.content.cloneNode(true);
        if(!content)return;
        this.querySelector('.charlox-demo__trigger').replaceWith(content);
        this.dataset.playing='true';
        const video=this.querySelector('video');
        if(video){video.focus();video.play().catch(()=>{});}
        else this.querySelector('iframe')?.focus();
      },{once:true});
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
